import React from 'react';
import { Drawer } from 'antd';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import CustomText from '../../../../atoms/CustomText';
import { moneyFormat } from '../../../../../services/util';
import { fieldsShape } from '../../organisms/SimuladorRe/initialState';
import Descriptions from '../../../../molecules/Descriptions';
import Description from '../../../../atoms/Description';
import Field from '../../atoms/Field';

const Container = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  grid-gap: 16px 8px;
`;

const CustomDrawer = styled(Drawer)`
  font-family: Hind, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto,
    'Helvetica Neue', Arial, 'Noto Sans', sans-serif, 'Apple Color Emoji',
    'Segoe UI Emoji', 'Segoe UI Symbol', 'Noto Color Emoji';

  & .ant-drawer-body {
    padding: 16px;
  }

  & .ant-drawer-body > div {
    margin-top: 16px;
  }
`;

function DrawerEmpresa({
  fields,
  isVisible,
  onClose,
  onChangeFieldValue,
  onBlurField,
  custosEmpresa,
}) {
  return (
    <CustomDrawer
      title={
        <CustomText fontSize="16px" color="#262626" strong>
          Custo Mensal para a Empresa
        </CustomText>
      }
      placement="right"
      closable
      open={isVisible}
      onClose={onClose}
      width={500}
    >
      <Description label="Custo Total:">
        <span data-testid="custoTotalEmpresa">
          {moneyFormat(custosEmpresa.custoTotal)}
        </span>
      </Description>
      <Container>
        {Object.entries(fields).map(
          ([
            id,
            { label, valueType, isVisible: isFieldVisible, isEnabled, value },
          ]) =>
            isFieldVisible && (
              <div key={id}>
                <Field
                  id={id}
                  label={label}
                  value={value}
                  isEnabled={isEnabled}
                  valueType={valueType}
                  onChangeFieldValue={onChangeFieldValue}
                  onBlurField={onBlurField}
                />
              </div>
            )
        )}
      </Container>
      <Descriptions column={{ lg: 3 }}>
        <Descriptions.Item label="FGTS">
          <span data-testid="fgts">{moneyFormat(custosEmpresa.fgts)}</span>
        </Descriptions.Item>
        <Descriptions.Item label="GPS / INSS">
          <span data-testid="gpsInss">
            {moneyFormat(custosEmpresa.gpsInss)}
          </span>
        </Descriptions.Item>
        <Descriptions.Item label="Provisão 13 Salário">
          <span data-testid="provisaoDecimoTerceiro">
            {moneyFormat(custosEmpresa.provisaoDecimoTerceiro)}
          </span>
        </Descriptions.Item>
        <Descriptions.Item label="Encargos 13 Salário">
          <span data-testid="encargosDecimoTerceiro">
            {moneyFormat(custosEmpresa.encargosDecimoTerceiro)}
          </span>
        </Descriptions.Item>
        <Descriptions.Item label="1/3 de férias">
          <span data-testid="feriasUmTerco">
            {moneyFormat(custosEmpresa.feriasUmTerco)}
          </span>
        </Descriptions.Item>
        <Descriptions.Item label="Encargos 1/3 de Férias">
          <span data-testid="encargosFeriasUmTerco">
            {moneyFormat(custosEmpresa.encargosFeriasUmTerco)}
          </span>
        </Descriptions.Item>
        <Descriptions.Item label="40% do FGTS - Rescisão">
          <span data-testid="fgtsRescisao">
            {moneyFormat(custosEmpresa.fgtsRescisao)}
          </span>
        </Descriptions.Item>
        <Descriptions.Item label="Total de Encargos">
          <span data-testid="totalEncargos">
            {moneyFormat(custosEmpresa.totalEncargos)}
          </span>
        </Descriptions.Item>
        <Descriptions.Item label="Total de Benefícios">
          <span data-testid="totalBeneficios">
            {moneyFormat(custosEmpresa.totalBeneficios)}
          </span>
        </Descriptions.Item>
      </Descriptions>
    </CustomDrawer>
  );
}

DrawerEmpresa.propTypes = {
  fields: fieldsShape.isRequired,
  isVisible: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onChangeFieldValue: PropTypes.func.isRequired,
  onBlurField: PropTypes.func.isRequired,
  custosEmpresa: PropTypes.shape({
    fgts: PropTypes.number,
    gpsInss: PropTypes.number,
    provisaoDecimoTerceiro: PropTypes.number,
    encargosDecimoTerceiro: PropTypes.number,
    feriasUmTerco: PropTypes.number,
    encargosFeriasUmTerco: PropTypes.number,
    fgtsRescisao: PropTypes.number,
    totalEncargos: PropTypes.number,
    totalBeneficios: PropTypes.number,
    custoTotal: PropTypes.number,
  }),
};

DrawerEmpresa.defaultProps = {
  custosEmpresa: {
    fgts: 0,
    gpsInss: 0,
    provisaoDecimoTerceiro: 0,
    encargosDecimoTerceiro: 0,
    feriasUmTerco: 0,
    encargosFeriasUmTerco: 0,
    fgtsRescisao: 0,
    totalEncargos: 0,
    totalBeneficios: 0,
    custoTotal: 0,
  },
};

export default DrawerEmpresa;
